import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Helper } from '../helper.service';
import { catchError, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { RoleSavePayload } from '../../models/role/role.model';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  options: any;

  constructor(
    private http: HttpClient,
    private helperService: Helper,
  ) {}

  getRoles(organizationId?: string | null): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    const url = organizationId ? `${environment.roleServiceEndPoint}/GetByOrganization/${organizationId}` : environment.roleServiceEndPoint;
    return this.http.get(url, this.options).pipe(catchError(this.helperService.handleError));
  }

  updateRolePermissions(roleId: string, permissionIds: string[]): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http
      .patch(`${environment.roleServiceEndPoint}/${roleId}/permissions`, { permissionIds }, this.options)
      .pipe(catchError(this.helperService.handleError));
  }

  addRole(payload: RoleSavePayload): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http.post(environment.roleServiceEndPoint, payload, this.options).pipe(catchError(this.helperService.handleError));
  }

  updateRole(roleId: string, payload: RoleSavePayload): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http
      .patch(`${environment.roleServiceEndPoint}/${roleId}`, payload, this.options)
      .pipe(catchError(this.helperService.handleError));
  }

  deleteRole(roleId: string): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http.delete(`${environment.roleServiceEndPoint}/${roleId}`, this.options).pipe(catchError(this.helperService.handleError));
  }
}
